import React from 'react';
import { Button } from '@mui/material';
import usePrequal from '../../resources/prequal/usePrequal';

const DeclinedCTA = () => {
  const { data: prequal } = usePrequal();

  if (prequal.redirectUri) {
    return (
      <Button href={prequal.redirectUri}>
        Return to Merchant
      </Button>
    );
  }

  if (prequal.preliminaryRedirectUri) {
    return (
      <Button href={prequal.preliminaryRedirectUri}>
        Return to Merchant
      </Button>
    );
  }

  return (
    <Button href={`/${process.env.PREFIX}/auth/logout`}>
      Sign Out
    </Button>
  );
};

export default DeclinedCTA;
